import { render, staticRenderFns } from "./log.vue?vue&type=template&id=5d96f5ff&scoped=true"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"
import style0 from "./log.vue?vue&type=style&index=0&id=5d96f5ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d96f5ff",
  null
  
)

export default component.exports